"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const apollo_link_1 = require("apollo-link");
const AuthHeadersLink_1 = require("./AuthHeadersLink");
const TokenRefreshLink_1 = require("./TokenRefreshLink");
class AuthLink extends apollo_link_1.ApolloLink {
    constructor(authLinkParameters) {
        super();
        const authHeadersLink = new AuthHeadersLink_1.AuthHeadersLink(authLinkParameters);
        const tokenRefreshLink = new TokenRefreshLink_1.TokenRefreshLink(authLinkParameters);
        this.link = apollo_link_1.ApolloLink.from([tokenRefreshLink, authHeadersLink]);
    }
    request(operation, forward) {
        return this.link.request(operation, forward);
    }
}
exports.AuthLink = AuthLink;
//# sourceMappingURL=AuthLink.js.map